(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["free-shipping-progress"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('free-shipping-progress')) {
    class FreeShippingProgress extends HTMLElement {
      connectedCallback() {
        this.messageElement = this.querySelector('[data-free-shipping-message] p');
        this.trackElement = this.querySelector('[data-free-shipping-track]');
        this.fillElement = this.querySelector('[data-free-shipping-fill]');
        this.threshold = Number(this.dataset.threshold);

        this.update(Number(this.dataset.cartTotal), this.dataset.currency);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      async refresh() {
        try {
          const cartUrl = window.routes?.cart_url || '/cart';
          const response = await fetch(`${cartUrl}.json`, {
            headers: { Accept: 'application/json' },
          });

          if (!response.ok) return;

          const cart = await response.json();
          this.update(Number(cart.total_price), cart.currency);
        } catch (error) {
          // The server-rendered state remains visible if the cart refresh fails.
        }
      }

      update(totalPrice, currency) {
        if (!Number.isFinite(totalPrice) || !this.threshold || !this.messageElement) return;

        const remaining = Math.max(this.threshold - totalPrice, 0);
        const progress = Math.min((totalPrice / this.threshold) * 100, 100);
        const unlocked = remaining === 0;
        const nearThreshold = !unlocked && progress > 70;

        this.classList.toggle('is-unlocked', unlocked);
        this.classList.toggle('is-near', nearThreshold);
        this.fillElement?.style.setProperty('--free-shipping-progress-width', `${progress}%`);
        this.trackElement?.setAttribute('aria-valuenow', String(Math.round(progress)));

        if (unlocked) {
          this.messageElement.textContent = this.dataset.unlockedMessage;
          return;
        }

        const amount = this.formatMoney(remaining, currency);
        const template = nearThreshold ? this.dataset.remainingNearTemplate : this.dataset.remainingLowTemplate;
        this.messageElement.textContent = template.replace('__AMOUNT__', amount);
      }

      formatMoney(amount, currency) {
        try {
          return new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang, {
            style: 'currency',
            currency: currency || this.dataset.currency || 'EUR',
          }).format(amount / 100);
        } catch (error) {
          return `${(amount / 100).toFixed(2)} €`;
        }
      }
    }

    customElements.define('free-shipping-progress', FreeShippingProgress);
  }
  } catch(e) { console.error(e); }
})();

})();
